import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=59566a02&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"
import style0 from "./blackList.vue?vue&type=style&index=0&id=59566a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59566a02",
  null
  
)

export default component.exports